import React from 'react';
import { Container } from 'react-bootstrap';

import { routePaths } from 'appConfig';
import { Link, Icon, Button } from 'components/common';

const EmptyCart = () => {
  return (
    <Container>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Icon
          name="shopping-cart"
          fontSize="15rem"
          style={{ lineHeight: 1 }}
        />
        <p className="px-3 py-2 cart-empty mb-3">
          No products added to the cart.{' '}
        </p>
        <Link to={routePaths.PRODUCTS}>
          <Button>Return to Shop</Button>
        </Link>
        <Link to={routePaths.ORDERS} className="tw-mt-4">
          <Button variant="outlined">Check My Orders</Button>
        </Link>
      </div>
    </Container>
  );
};

EmptyCart.propTypes = {};

export default EmptyCart;
